import {EntityFactory, Reducer} from '@modifi/redux'
import {getAuthenticatedShipmentsClient, UserSettingView} from '../../lib'

const apiClient = getAuthenticatedShipmentsClient()

const {reducer, actions, selectors} = EntityFactory({
  rootSelector: state => state?.data?.userSettings?.entity,
  actionNamePrefix: 'data/user-settings/entity',
  fetchRequest: () => apiClient.UserSettings.fetch().then(res => res.data()),
})

export default reducer as Reducer

export const {selectEntity: selectUserSettings} = selectors

// @todo type to fix
export const aFetchUserSettings = (): any => actions!.fetch({})

export const aUpdateLocalUserSettings = (userSettings: Partial<UserSettingView>): any =>
  actions?.update(userSettings, true)
